import type { ChatMessage } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import type { Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import styles from './index.module.scss';

export const deleteMessage = (message: ChatMessage, chat: Chat) => {
  let value = false;

  const Content = ({
    checked,
    onChange,
  }: {
    checked: boolean;
    onChange: (value: boolean) => void;
  }) => {
    const [value, setValue] = useState(checked);
    return (
      <Checkbox
        className={styles.checkbox}
        checked={value}
        onChange={(e) => {
          setValue(e.target.checked);
          onChange?.(e.target.checked);
        }}
      >
        <div className={styles.checkboxContent}>Also delete for {chat.name}</div>
      </Checkbox>
    );
  };
  Dialog({
    title: 'Do you want to delete this message?',
    content: (
      <Content
        checked={value}
        onChange={(checked) => {
          value = checked;
        }}
      />
    ),
    onConfirm: () => {
      console.log('Delete', value, message, chat);
    },
  });
};
